import type { SVGAttributes } from 'react';

export function EnglishIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_328_580)">
				<circle cx="8" cy="8" r="8" fill="#F0F0F0" />
				<path d="M1.65 3.13c-.63.82-1.1 1.76-1.38 2.78h4.16L1.65 3.13Z" fill="#0052B4" />
				<path d="M15.72 5.91a8 8 0 0 0-1.38-2.78l-2.78 2.78h4.16Z" fill="#0052B4" />
				<path d="M.28 10.09a8 8 0 0 0 1.38 2.78l2.78-2.78H.28Z" fill="#0052B4" />
				<path d="M12.87 1.65a8 8 0 0 0-2.78-1.38v4.16l2.78-2.78Z" fill="#0052B4" />
				<path d="M3.13 14.35c.82.63 1.76 1.1 2.78 1.38v-4.16l-2.78 2.78Z" fill="#0052B4" />
				<path d="M5.91.28a8 8 0 0 0-2.78 1.37l2.78 2.78V.28Z" fill="#0052B4" />
				<path d="M10.09 15.72a8 8 0 0 0 2.78-1.38l-2.78-2.78v4.16Z" fill="#0052B4" />
				<path d="M11.56 10.09l2.78 2.78a8 8 0 0 0 1.38-2.78h-4.16Z" fill="#0052B4" />
				<path
					d="M15.93 6.96H9.04V.07a8 8 0 0 0-2.09 0v6.89H.07a8 8 0 0 0 0 2.08h6.89v6.89a8 8 0 0 0 2.08 0V9.04h6.89a8 8 0 0 0 0-2.08Z"
					fill="#D80027"
				/>
				<path d="M10.09 10.09l3.57 3.57c.16-.16.32-.34.47-.51l-3.06-3.06h-.98Z" fill="#D80027" />
				<path d="M5.91 10.09l-3.57 3.57c.16.16.34.32.51.47l3.06-3.06v-.98Z" fill="#D80027" />
				<path d="M5.91 5.91L2.34 2.34c-.16.16-.32.34-.47.51l3.06 3.06h.98Z" fill="#D80027" />
				<path d="M10.09 5.91l3.57-3.57c-.16-.16-.34-.32-.51-.47l-3.06 3.06v.98Z" fill="#D80027" />
			</g>
			<defs>
				<clipPath id="clip0_328_580">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
